/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import { ViewCheckedAttributes } from './view-checked-attributes';
import { ViewEditableAttributes } from './view-editable-attributes';
import { ViewMediaPlayerAttributes } from './view-media-player-attributes';
import { ViewTextSelectionAttributes } from './view-text-selection-attributes';

export enum ViewStateAttribute {
  NONE = 0,
  ViewCheckedAttributes = 1,
  ViewMediaPlayerAttributes = 2,
  ViewTextSelectionAttributes = 3,
  ViewEditableAttributes = 4,
}

export function unionToViewStateAttribute(
  type: ViewStateAttribute,
  accessor: (
    obj:
      | ViewCheckedAttributes
      | ViewEditableAttributes
      | ViewMediaPlayerAttributes
      | ViewTextSelectionAttributes,
  ) =>
    | ViewCheckedAttributes
    | ViewEditableAttributes
    | ViewMediaPlayerAttributes
    | ViewTextSelectionAttributes
    | null,
):
  | ViewCheckedAttributes
  | ViewEditableAttributes
  | ViewMediaPlayerAttributes
  | ViewTextSelectionAttributes
  | null {
  switch (ViewStateAttribute[type]) {
    case 'NONE':
      return null;
    case 'ViewCheckedAttributes':
      return accessor(new ViewCheckedAttributes())! as ViewCheckedAttributes;
    case 'ViewMediaPlayerAttributes':
      return accessor(new ViewMediaPlayerAttributes())! as ViewMediaPlayerAttributes;
    case 'ViewTextSelectionAttributes':
      return accessor(new ViewTextSelectionAttributes())! as ViewTextSelectionAttributes;
    case 'ViewEditableAttributes':
      return accessor(new ViewEditableAttributes())! as ViewEditableAttributes;
    default:
      return null;
  }
}

export function unionListToViewStateAttribute(
  type: ViewStateAttribute,
  accessor: (
    index: number,
    obj:
      | ViewCheckedAttributes
      | ViewEditableAttributes
      | ViewMediaPlayerAttributes
      | ViewTextSelectionAttributes,
  ) =>
    | ViewCheckedAttributes
    | ViewEditableAttributes
    | ViewMediaPlayerAttributes
    | ViewTextSelectionAttributes
    | null,
  index: number,
):
  | ViewCheckedAttributes
  | ViewEditableAttributes
  | ViewMediaPlayerAttributes
  | ViewTextSelectionAttributes
  | null {
  switch (ViewStateAttribute[type]) {
    case 'NONE':
      return null;
    case 'ViewCheckedAttributes':
      return accessor(index, new ViewCheckedAttributes())! as ViewCheckedAttributes;
    case 'ViewMediaPlayerAttributes':
      return accessor(index, new ViewMediaPlayerAttributes())! as ViewMediaPlayerAttributes;
    case 'ViewTextSelectionAttributes':
      return accessor(index, new ViewTextSelectionAttributes())! as ViewTextSelectionAttributes;
    case 'ViewEditableAttributes':
      return accessor(index, new ViewEditableAttributes())! as ViewEditableAttributes;
    default:
      return null;
  }
}
